import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../../utils/store';
import { useEffect, useState, useRef } from 'react';
import HttpService from '../../../services/HttpService';
import Constants from '../../../utils/constants';
import FormFieldData from '../../../Models/FormFieldData';
import {
  Box,
  Checkbox,
  FormControlLabel,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import CommonForm from '../../../components/form/CommonForm';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import IdLabelData from '../../../Models/IdLabelData';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { getCurrentDate } from '../../../utils/storageUtil';
import AssetDocuments from './parts/AssetsDocuments';
import { useAlert } from '../../../components/alertContext';
import Grid from '@mui/material/Grid2';
import CheckBoxFieldComponent from '../../../components/form/CheckBoxFields';

const MobileAssetForm: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const { currentId } = useParams<{ currentId: any }>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { alert, setAlert, handleCloseAlert } = useAlert();

  const [currentRecord, setCurrentRecord] = useState<any>(null);
  type formData = {
    [k: string]: { required: boolean; value: string | null | number | boolean };
  };
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [assetTypeList, setAssetTypeList] = useState<IdLabelData[]>([]);
  const [contractorList, setContractorList] = useState<IdLabelData[]>([]);
  const [resourceList, setResourceList] = useState<IdLabelData[]>([]);
  const [faultList, setFaultList] = useState<IdLabelData[]>([]);
  const [checkedFault, setCheckedFault] = useState<number[]>([-1]);
  const [form, setForm] = useState<formData>({
    id: { required: false, value: null },
    assetNumber: { required: true, value: '' },
    assetName: { required: true, value: '' },
    assetTypeId: { required: true, value: 0 },
    assetCost: { required: true, value: '' },
    purchaseDate: { required: true, value: getCurrentDate() },
    registrationDate: { required: true, value: getCurrentDate() },
    nextServiceDate: { required: true, value: getCurrentDate() },
    isHired: { required: true, value: false },
    contractorId: { required: true, value: '' },
    resourceItemId: { required: true, value: '' },
    isOutofService: { required: true, value: false },
    outofServiceFrom: { required: true, value: getCurrentDate() },
    outofServiceTo: { required: true, value: getCurrentDate() },
  });
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState('1');
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };
  const handleToggle = (value: any) => {
    console.log(value, '<<<<<<<<<<<<<<');
    if (checkedFault.length > 0) {
      const currentIndex = checkedFault.indexOf(value);
      const newChecked = [...checkedFault];
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      setCheckedFault(newChecked);
    }
  };
  const handleRowClick = (record: any) => {
    if (record.isFaultRaised) {
      fetchFaults(record.id);
    }

    setCurrentRecord(record);
    setForm({
      id: { required: false, value: record.id },
      assetNumber: { required: true, value: record.assetNumber },
      assetName: { required: true, value: record.assetName },
      assetTypeId: { required: true, value: record.assetTypeId },
      assetCost: { required: true, value: record.assetCost },
      purchaseDate: { required: true, value: record.purchaseDate },
      registrationDate: { required: true, value: record.registrationDate },
      nextServiceDate: { required: true, value: record.nextServiceDate },
      isHired: { required: true, value: record.isHired },
      contractorId: { required: true, value: record.contractorId },
      resourceItemId: { required: true, value: record.resourceItemId },
      isOutofService: { required: true, value: record.isOutofService },
      outofServiceFrom: { required: true, value: record.outofServiceFrom },
      outofServiceTo: { required: true, value: record.outofServiceTo },
    });
  };
  const fetchAssetTypeList = async () => {
    try {
      const dataList: any = await fetchBundle('fetchAssetTypes');
      if (dataList) {
        setAssetTypeList([{ id: '', name: 'Select Type' }, ...dataList]);
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchFaults = async (id: any) => {
    try {
      const URL = `${Constants.apiURL}/map/faults/${id}`;
      const response = await HttpService.get(URL, {
        headers: { Authorization: 'Bearer ' + getAdmin() },
      });
      if (response.data) {
        console.log('--------1');
        setFaultList(response.data);
      } else {
        setFaultList([]);
      }
    } catch (error: any) {
      setFaultList([]);
    }
  };
  const fetchBundle = async (type: string) => {
    return new Promise(async (resolve, reject) => {
      try {
        const URL = `${Constants.apiURL}${Constants.refBundleURL}/${type}`;
        const response = await HttpService.get(
          URL,
          { headers: { Authorization: 'Bearer ' + getAdmin() } },
          { search: '', limit: -1, offset: 0 }
        );
        if (response.data) {
          resolve(response.data);
        } else {
          reject('Failed to Fetch List. Please try again.');
        }
        console.log('GET Response:', response);
      } catch (error: any) {
        reject('Failed to Find List. Please try again.');

        console.error(`GET Error:`, error);
        setAlert({
          type: 'error',
          message: error.message,
          open: true,
        });
      }
    });
  };
  const fetchContractors = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.contractorsURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1, offset: 0 }
      );
      if (response.success) {
        setContractorList([
          { id: 0, label: 'Select Contractor' }, // Default option
          ...response.data.paginateRecords.map((item: any) => ({
            id: item.id,
            label: item.name,
          })),
        ]);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchSingleRecord = async (id: string) => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.mobileAssetsURL}/${id}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        null
      );
      if (response.success) {
        handleRowClick(response.data);
      }
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const clearForm = () => {
    setForm({
      id: { required: false, value: null },
      assetNumber: { required: true, value: '' },
      assetName: { required: true, value: '' },
      assetTypeId: { required: true, value: '' },
      assetCost: { required: true, value: '' },
      purchaseDate: { required: true, value: getCurrentDate() },
      registrationDate: { required: true, value: getCurrentDate() },
      nextServiceDate: { required: true, value: getCurrentDate() },
      isHired: { required: true, value: false },
      contractorId: { required: true, value: '' },
      resourceItemId: { required: true, value: '' },
      isOutofService: { required: true, value: false },
      outofServiceFrom: { required: true, value: getCurrentDate() },
      outofServiceTo: { required: true, value: getCurrentDate() },
    });
    setCheckedFault([-1]);
    setAlert({
      type: 'error',
      message: '',
      open: false,
    });
    setCurrentRecord(null);
    navigate('/data-management/mobile-assets');
  };

  const handleSave = async () => {
    const passedFaults = faultList
      .filter((item: any) => checkedFault.includes(item.questionId))
      .map((itemMap: any) => {
        return {
          questionId: itemMap.questionId,
          sectionId: itemMap.sectionId,
          answer: 'Pass',
        };
      });

    if (form.isHired.value) {
      if (!form.contractorId.value) {
        setAlert({
          type: 'error',
          message: 'Contractor ID is required',
          open: true,
        });
        return false;
      }
      if (!form.resourceItemId.value) {
        setAlert({
          type: 'error',
          message: 'Resource item ID is required',
          open: true,
        });
        return false;
      }
    }
    if (form.isOutofService.value) {
      if (!form.outofServiceFrom.value) {
        setAlert({
          type: 'error',
          message: 'Out of service start date is required',
          open: true,
        });
        return false;
      }
      if (!form.outofServiceTo.value) {
        setAlert({
          type: 'error',
          message: 'Out of service end date is required',
          open: true,
        });
        return false;
      }
    }
    setLoading(true);
    const reqData: any = {
      assetNumber: form.assetNumber.value,
      assetName: form.assetName.value,
      assetTypeId: form.assetTypeId.value,
      assetCost: form.assetCost.value,
      purchaseDate: form.purchaseDate.value,
      registrationDate: form.registrationDate.value,
      nextServiceDate: form.nextServiceDate.value,
      isHired: form.isHired.value,
      contractorId: form.contractorId.value,
      resourceItemId: form.resourceItemId.value,
      isOutofService: form.isOutofService.value,
      outofServiceFrom: form.outofServiceFrom.value,
      outofServiceTo: form.outofServiceTo.value,
    };
    const endpoint = `${Constants.apiURL + Constants.mobileAssetsURL}`;
    let response: any;
    try {
      if (currentRecord) {
        reqData['id'] = form.id.value;
        response = await HttpService.put(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
        if (passedFaults.length > 0) {
          const endpointMap = `${Constants.apiURL}/map/resolvefaults/${form.id.value}`;
          await HttpService.put(
            endpointMap,
            { answers: passedFaults },
            {
              headers: { Authorization: `Bearer ${getAdmin()}` },
            }
          );
        }
      } else {
        response = await HttpService.post(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      }

      if (response.success) {
        clearForm();
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<any>) => {
    const { name, value, type } = e.target;

    if (type === 'checkbox') {
      setForm((prev) => ({
        ...prev,
        [name]: { required: prev[name].required, value: e.target.checked },
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: { required: prev[name].required, value: value },
      }));
    }
  };
  const handleDateChange = (value: any, type: string) => {
    const expiryDateValue =
      value.year() + '-' + (value.month() + 1) + '-' + value.date();
    setForm((prev: any) => {
      return {
        ...prev,
        [type]: {
          required: prev[type].required,
          value: expiryDateValue,
        },
      };
    });
  };

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      loadDataList();
    }
  }, [currentId]);

  const loadDataList = async () => {
    setIsLoading(true);
    if (assetTypeList.length === 0) await fetchAssetTypeList();

    if (contractorList.length === 0) await fetchContractors();
    if (resourceList.length === 0) await getResourceList();
    if (currentId !== 'Add') {
      await fetchSingleRecord(currentId);
    }
    setIsLoading(false);
  };
  const getResourceList = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.resourcesURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { isActive: '1' }
      );
      if (response.success) {
        const resourceRecords = response.data.paginateRecords;
        if (resourceRecords.length > 0) {
          setResourceList([
            { id: '', name: 'Select Resource' },
            ...resourceRecords,
          ]);
        }
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleConfirmDialog = async (type: string) => {
    if (type === 'Yes') {
      setConfirmDialogOpen(false);
      setConfirmDialogOpen(false);
      navigate(`/data-management/mobile-assets`);
      clearForm();
    } else {
      setConfirmDialogOpen(false);
      return false;
    }
  };
  const getFaultBox = () => {
    console.log('--------2', faultList.length);
    return faultList.length > 0 ? (
      <Box>
        <Typography variant="h6">
          Currrent Faults
          <small style={{ fontSize: '11px', marginLeft: '10px' }}>
            {' '}
            (Mark the resolved Faults.)
          </small>
        </Typography>

        {faultList.map((item: any, index: any) => {
          return (
            <Box>
              <FormControlLabel
                id={`lbl${item.questionId}_${item.sectionId}_lbl`}
                key={`lbl${item.questionId}_${item.sectionId}_lbl`}
                control={
                  <Checkbox
                    key={`chk${item.questionId}_${item.sectionId}_lbl`}
                    name={`chck${item.questionId}_${item.sectionId}_lbl`}
                    onChange={(e) => {
                      console.log(e);
                      handleToggle(item.questionId);
                    }}
                    value={item.questionId}
                    checked={checkedFault.includes(item.questionId)}
                  />
                }
                label={item.question}
              />
            </Box>
          );
        })}
      </Box>
    ) : (
      <Box></Box>
    );
  };
  const formFields: FormFieldData[] = [
    {
      name: 'assetNumber',
      label: 'Asset Number',
      value: form.assetNumber.value,
      onChange: handleInputChange,
      isRequired: form.assetNumber.required,
      size: 4,
      type: 'textfield',
      validationRules: [
        (value) => (!value ? 'Asset Number is required' : null),
      ],
    },
    {
      name: 'assetName',
      label: 'Asset name',
      value: form.assetName.value,
      onChange: handleInputChange,
      isRequired: form.assetName.required,
      size: 4,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Asset name is required' : null)],
    },
    {
      name: 'assetTypeId',
      label: 'Asset Type',
      value: form.assetTypeId.value,
      onChange: handleInputChange,
      isRequired: form.assetTypeId.required,
      size: 4,
      type: 'selectField',
      options: assetTypeList,
      disabled: currentId !== 'Add',
      validationRules: [(value) => (!value ? 'Asset Type is required' : null)],
    },
    {
      name: 'assetCost',
      label: 'Asset Cost',
      value: form.assetCost.value,
      onChange: handleInputChange,
      inputType: 'number',
      isRequired: form.assetCost.required,
      size: 4,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Asset Cost is required' : null)],
    },
    {
      name: 'purchaseDate',
      label: 'Purchase Date',
      value: form.purchaseDate.value,
      onChange: (value: any) => {
        handleDateChange(value, 'purchaseDate');
      },
      isRequired: true,
      type: 'datepicker',
      size: 4,
      validationRules: [(value) => (!value ? 'Purchase Date is required' : '')],
      keyname: 'purchaseDate',
    },
    {
      name: 'registrationDate',
      label: 'Registration Date',
      value: form.registrationDate.value,
      onChange: (value: any) => {
        handleDateChange(value, 'registrationDate');
      },
      isRequired: true,
      type: 'datepicker',
      size: 4,
      validationRules: [
        (value) => (!value ? 'Registration Date is required' : ''),
      ],
      keyname: 'registrationDate',
    },
    {
      name: 'nextServiceDate',
      label: 'Next Service Date',
      value: form.nextServiceDate.value,
      onChange: (value: any) => {
        handleDateChange(value, 'nextServiceDate');
      },
      isRequired: true,
      type: 'datepicker',
      size: 4,
      validationRules: [
        (value) => (!value ? 'Next Service Date is required' : ''),
      ],
      keyname: 'nextServiceDate',
    },
    {
      name: 'isHired',
      label: 'Hired',
      value: form.isHired.value,
      onChange: handleInputChange,
      isRequired: false,
      keyname: 'isHired',
      type: 'switchField',
      checked: form.isHired.value ? true : false,
      size: 12,
    },
    {
      name: 'contractorId',
      label: 'Contractor',
      value: form.contractorId.value,
      onChange: handleInputChange,
      isRequired: form.contractorId.required,
      isHidden: !form.isHired.value,
      size: 4,
      options: contractorList,
      type: 'selectField',
    },
    {
      name: 'resourceItemId',
      label: 'Resource Item',
      value: form.resourceItemId.value,
      onChange: handleInputChange,
      isRequired: form.resourceItemId.required,
      isHidden: !form.isHired.value,
      size: 4,
      options: resourceList,
      type: 'selectField',
    },

    {
      name: 'isOutofService',
      label: 'Out of Service',
      value: form.isOutofService.value,
      onChange: handleInputChange,
      isRequired: false,
      checked: form.isOutofService.value ? true : false,
      type: 'switchField',
      size: 12,
    },
    {
      name: 'outofServiceFrom',
      label: 'From',
      value: form.outofServiceFrom.value,
      onChange: (value: any) => {
        handleDateChange(value, 'nextServiceDate');
      },
      isRequired: true,
      type: 'datepicker',
      isHidden: !form.isOutofService.value,
      size: 4,

      keyname: 'outofServiceFrom',
    },
    {
      name: 'outofServiceTo',
      label: 'to',
      value: form.outofServiceTo.value,
      onChange: (value: any) => {
        handleDateChange(value, 'nextServiceDate');
      },
      isRequired: true,
      isHidden: !form.isOutofService.value,
      type: 'datepicker',
      size: 4,
      keyname: 'outofServiceTo',
    },
    {
      name: 'customFualt',
      label: 'Current Faults',
      value: '',
      onChange: () => {},
      isRequired: false,
      isHidden: currentId === 'Add',
      size: 12,
      options: [],
      customComponent: getFaultBox(),
      type: 'custom',
    },
  ];

  return (
    <Stack>
      <Box sx={{ width: '100%', marginTop: '35px', marginBottom: '35px' }}>
        <Box
          onClick={() => setConfirmDialogOpen(true)}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <Typography variant="h6">
            <UTurnLeftIcon
              style={{
                transform: 'rotate(90deg)',
                cursor: 'pointer',
                marginTop: '4px',
              }}
              onClick={() => {
                setConfirmDialogOpen(true);
              }}
            />
          </Typography>
          <Typography variant="h6">Back</Typography>
        </Box>
        <Paper
          elevation={3}
          sx={{
            backgroundColor: '#ffffff',
          }}
        >
          {isLoading && (
            <Box sx={{ width: '100%', mt: 3 }}>
              <LinearProgress />
            </Box>
          )}
          <Typography
            variant="h6"
            style={{ paddingLeft: '30px', paddingTop: '30px' }}
          >
            {currentId !== 'Add'
              ? 'Update Mobile Asset'
              : 'Add New Mobile Asset'}
          </Typography>

          <Box
            sx={{
              padding: '10px',
              paddingBottom: '100px',

              margin: '0 auto 35px auto',
            }}
          >
            <Tabs
              sx={{
                '& .MuiTab-root': {
                  textTransform: 'none',
                  color: '#000B29',
                },
                '& .Mui-selected': {
                  color: '#000B29',
                  borderBottom: '2px solid #000B29',
                  fontSize: '14px',
                },
              }}
              value={currentTab}
              onChange={handleTabChange}
            >
              <Tab value="1" label="Overview" wrapped />
              {currentId !== 'Add' && <Tab value="2" label="Documents" />}
            </Tabs>
            {currentTab === '1' && (
              <CommonForm
                singlePage={true}
                fields={formFields}
                onCancel={() => {}}
                formReset={clearForm}
                formTitle={''}
                isLoading={loading}
                isUpdate={currentId !== 'Add' ? true : false}
                onSave={handleSave}
                actionButtonPosition="bottom"
              />
            )}
            {currentTab === '2' && currentId !== 'Add' && (
              <Box>
                <AssetDocuments mobileAssetId={currentId}></AssetDocuments>
              </Box>
            )}
          </Box>
          <ConfirmDialog
            handleClose={handleConfirmDialog}
            message="Are you sure, you want to exit?"
            open={confirmDialogOpen}
          ></ConfirmDialog>
          <AlertMessageComponent
            type={alert.type}
            open={alert.open}
            handleClose={handleCloseAlert}
            message={alert.message}
          />
        </Paper>
      </Box>
    </Stack>
  );
};

export default MobileAssetForm;
